// document.addEventListener("DOMContentLoaded", function () {
//   // === Helper Functions ===
//   function getWishlist() {
//     return JSON.parse(localStorage.getItem('wishlist')) || [];
//   }

//   function saveWishlist(wishlist) {
//     localStorage.setItem('wishlist', JSON.stringify(wishlist));
//   }

//   function isInWishlist(handle) {
//     return getWishlist().includes(handle);
//   }

//   function updateWishlistCount() {
//     const count = getWishlist().length;
//     document.querySelectorAll('[data-wishlist-count]').forEach(el => {
//       el.textContent = count;
//     });
//   }

//   function toggleWishlist(handle) {
//     let wishlist = getWishlist();
//     if (wishlist.includes(handle)) {
//       wishlist = wishlist.filter(item => item !== handle);
//     } else {
//       wishlist.push(handle);
//     }
//     saveWishlist(wishlist);
//     updateWishlistCount();
//   }

//   // === Core logic to bind buttons ===
//   function bindWishlistButtons(scope = document) {
//     const wishlistButtons = scope.querySelectorAll('.wishlist-button');

//     wishlistButtons.forEach(button => {
//       const handle = button.dataset.productHandle;
//       if (!handle) return;

//       if (isInWishlist(handle)) {
//         button.classList.add('active');
//       } else {
//         button.classList.remove('active');
//       }

//       if (!button.dataset.bound) {
//         button.addEventListener('click', function (e) {
//           e.preventDefault();
//           e.stopPropagation();
//           toggleWishlist(handle);
//           button.classList.toggle('active');
//         });
//         button.dataset.bound = "true";
//       }
//     });
//   }

//   // === Initial run ===
//   updateWishlistCount();
//   bindWishlistButtons();

//   // === Observe dynamically added content ===
//   const observer = new MutationObserver(mutations => {
//     mutations.forEach(mutation => {
//       mutation.addedNodes.forEach(node => {
//         if (node.nodeType === 1) {
//           if (node.matches('.product-recommendations') || node.querySelector('.wishlist-button')) {
//             bindWishlistButtons(node);
//           }
//         }
//       });
//     });
//   });

//   observer.observe(document.body, {
//     childList: true,
//     subtree: true
//   });

//   // === Wishlist page logic ===
//   const wishlistPage = document.getElementById('wishlist-page');
//   if (wishlistPage) {
//     const container = document.getElementById('wishlist-products');
//     const wishlist = getWishlist();

//     if (!wishlist.length) {
//       container.innerHTML = "<p>Your wishlist is empty.</p>";
//       return;
//     }

//     container.innerHTML = '<p>Loading your wishlist...</p>';

//     Promise.all(
//       wishlist.map(handle =>
//         fetch(`/products/${handle}.js`)
//           .then(res => res.ok ? res.json() : null)
//           .catch(() => null)
//       )
//     ).then(products => {
//       const validProducts = products.filter(Boolean);
//       if (!validProducts.length) {
//         container.innerHTML = '<p>No valid products found in your wishlist.</p>';
//         return;
//       }

//       container.innerHTML = '';

//       validProducts.forEach(product => {
//         const price = (product.price / 100).toFixed(2);
//         const html = `
//           <div class="wishlist-item" data-handle="${product.handle}">
//             <a href="${product.url}" class="wishlist-link">
//               <img src="${product.images[0]}" alt="${product.title}" class="wishlist-image" />
//               <h3>${product.title}</h3>
//               <p>₹${price}</p>
//             </a>
//             <div class="wishlist-actions">
//               <button class="wishlist-move-cart" data-id="${product.variants[0].id}">Move to Cart</button>
//               <button class="wishlist-delete-icon" data-handle="${product.handle}" title="Remove from Wishlist">🗑️</button>
//             </div>
//           </div>
//         `;
//         container.insertAdjacentHTML('beforeend', html);
//       });

//       // === Move to Cart with loading + open cart drawer ===
//       document.querySelectorAll('.wishlist-move-cart').forEach(button => {
//   button.addEventListener('click', function () {
//     const variantId = this.dataset.id;
//     const itemEl = this.closest('.wishlist-item');
//     const handle = itemEl.dataset.handle;

//     // Show loading state
//     button.disabled = true;
//     const originalText = button.innerHTML;
//     button.innerHTML = 'Moving...';

//     fetch('/cart/add.js', {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify({ id: variantId, quantity: 1 })
//     })
//       .then(res => res.json())
//       .then(() => {
//         toggleWishlist(handle);
//         itemEl.remove();
//         updateWishlistCount();

//         // ✅ Reload the cart drawer section
//         fetch('/?sections=sections--17738718183563__cart-drawer')
//           .then(res => res.json())
//           .then(data => {
//             const newDrawerHTML = data['sections--17738718183563__cart-drawer'];
//             const newDrawer = new DOMParser().parseFromString(newDrawerHTML, 'text/html').body.firstElementChild;
//             const oldDrawer = document.querySelector('cart-drawer');

//             if (oldDrawer && newDrawer) {
//               oldDrawer.replaceWith(newDrawer);

//               if (!newDrawer.hasAttribute('open')) {
//                 newDrawer.setAttribute('open', '');
//               }

//               newDrawer.scrollTop = 0;
//             }
//           });

//         if (getWishlist().length === 0) {
//           document.getElementById('wishlist-products').innerHTML = "<p>Your wishlist is empty.</p>";
//         }
//       })
//       .catch(err => {
//         console.error('Add to cart failed', err);
//         alert("Failed to add to cart.");
//         button.disabled = false;
//         button.innerHTML = originalText;
//       });
//   });
// });


//       // === Delete from wishlist only with loading ===
//       document.querySelectorAll('.wishlist-delete-icon').forEach(button => {
//         button.addEventListener('click', function () {
//           const handle = this.dataset.handle;
//           const itemEl = this.closest('.wishlist-item');

//           // Show loading icon
//           button.disabled = true;
//           const originalText = button.innerHTML;
//           button.innerHTML = '<svg width="60" height="60" viewBox="0 0 38 38"><g transform="translate(19 19)"><g transform="rotate(0)"><circle cx="0" cy="12" r="3" fill="#60A5FA" opacity="0.125"><animate attributeName="opacity" from="0.125" to="0.125" dur="1.2s" begin="0s" repeatCount="indefinite" keyTimes="0;1" values="1;0.125"></animate></circle></g><g transform="rotate(45)"><circle cx="0" cy="12" r="3" fill="#60A5FA" opacity="0.25"><animate attributeName="opacity" from="0.25" to="0.25" dur="1.2s" begin="0.15s" repeatCount="indefinite" keyTimes="0;1" values="1;0.25"></animate></circle></g><g transform="rotate(90)"><circle cx="0" cy="12" r="3" fill="#60A5FA" opacity="0.375"><animate attributeName="opacity" from="0.375" to="0.375" dur="1.2s" begin="0.3s" repeatCount="indefinite" keyTimes="0;1" values="1;0.375"></animate></circle></g><g transform="rotate(135)"><circle cx="0" cy="12" r="3" fill="#60A5FA" opacity="0.5"><animate attributeName="opacity" from="0.5" to="0.5" dur="1.2s" begin="0.44999999999999996s" repeatCount="indefinite" keyTimes="0;1" values="1;0.5"></animate></circle></g><g transform="rotate(180)"><circle cx="0" cy="12" r="3" fill="#60A5FA" opacity="0.625"><animate attributeName="opacity" from="0.625" to="0.625" dur="1.2s" begin="0.6s" repeatCount="indefinite" keyTimes="0;1" values="1;0.625"></animate></circle></g><g transform="rotate(225)"><circle cx="0" cy="12" r="3" fill="#60A5FA" opacity="0.75"><animate attributeName="opacity" from="0.75" to="0.75" dur="1.2s" begin="0.75s" repeatCount="indefinite" keyTimes="0;1" values="1;0.75"></animate></circle></g><g transform="rotate(270)"><circle cx="0" cy="12" r="3" fill="#60A5FA" opacity="0.875"><animate attributeName="opacity" from="0.875" to="0.875" dur="1.2s" begin="0.8999999999999999s" repeatCount="indefinite" keyTimes="0;1" values="1;0.875"></animate></circle></g><g transform="rotate(315)"><circle cx="0" cy="12" r="3" fill="#60A5FA" opacity="1"><animate attributeName="opacity" from="1" to="1" dur="1.2s" begin="1.05s" repeatCount="indefinite" keyTimes="0;1" values="1;1"></animate></circle></g></g></svg>';

//           setTimeout(() => {
//             toggleWishlist(handle);
//             itemEl.remove();
//             updateWishlistCount();

//             if (getWishlist().length === 0) {
//               container.innerHTML = "<p>Your wishlist is empty.</p>";
//             }
//           }, 300);
//         });
//       });
//     });
//   }
// });


// document.addEventListener("DOMContentLoaded", function () {

//   /* ===============================
//      Wishlist Helpers
//   =============================== */
//   function getWishlist() {
//     return JSON.parse(localStorage.getItem('wishlist')) || [];
//   }

//   function saveWishlist(wishlist) {
//     localStorage.setItem('wishlist', JSON.stringify(wishlist));
//   }

//   function isInWishlist(handle) {
//     return getWishlist().includes(handle);
//   }

//   function updateWishlistCount() {
//     const count = getWishlist().length;
//     document.querySelectorAll('[data-wishlist-count]').forEach(el => {
//       el.textContent = count;
//     });
//   }

//   function toggleWishlist(handle) {
//     let wishlist = getWishlist();
//     if (wishlist.includes(handle)) {
//       wishlist = wishlist.filter(item => item !== handle);
//     } else {
//       wishlist.push(handle);
//     }
//     saveWishlist(wishlist);
//     updateWishlistCount();
//   }

//   /* ===============================
//      Cart Helpers
//   =============================== */
//   function openCartDrawer() {
//     const drawer = document.querySelector('.cart-drawer__dialog');
//     if (!drawer) return;

//     drawer.classList.add('active');
//     drawer.setAttribute('open', '');
//     document.body.classList.add('overflow-hidden');
//   }

//   function updateCartCount(count) {
//     document.querySelectorAll('.cart-bubble__background').forEach(el => {
//       el.textContent = count;
//     });
//   }

//   function refreshCart() {
//     fetch('/cart.js')
//       .then(res => res.json())
//       .then(cart => {
//         updateCartCount(cart.item_count);

//         // Notify theme if it listens to cart updates
//         document.dispatchEvent(
//           new CustomEvent('cart:updated', { detail: cart })
//         );
//       });
//   }

//   /* ===============================
//      Bind Wishlist Buttons
//   =============================== */
//   function bindWishlistButtons(scope = document) {
//     const buttons = scope.querySelectorAll('.wishlist-button');

//     buttons.forEach(button => {
//       const handle = button.dataset.productHandle;
//       if (!handle) return;

//       button.classList.toggle('active', isInWishlist(handle));

//       if (!button.dataset.bound) {
//         button.addEventListener('click', function (e) {
//           e.preventDefault();
//           e.stopPropagation();
//           toggleWishlist(handle);
//           button.classList.toggle('active');
//         });
//         button.dataset.bound = "true";
//       }
//     });
//   }

//   updateWishlistCount();
//   bindWishlistButtons();

//   /* ===============================
//      Observe Dynamic Content
//   =============================== */
//   const observer = new MutationObserver(mutations => {
//     mutations.forEach(mutation => {
//       mutation.addedNodes.forEach(node => {
//         if (node.nodeType === 1 && node.querySelector('.wishlist-button')) {
//           bindWishlistButtons(node);
//         }
//       });
//     });
//   });

//   observer.observe(document.body, { childList: true, subtree: true });

//   /* ===============================
//      Wishlist Page Logic
//   =============================== */
//   const wishlistPage = document.getElementById('wishlist-page');
//   if (!wishlistPage) return;

//   const container = document.getElementById('wishlist-products');
//   const wishlist = getWishlist();

//   if (!wishlist.length) {
//     container.innerHTML = "<p>Your wishlist is empty.</p>";
//     return;
//   }

//   container.innerHTML = "<p>Loading your wishlist...</p>";

//   Promise.all(
//     wishlist.map(handle =>
//       fetch(`/products/${handle}.js`)
//         .then(res => res.ok ? res.json() : null)
//         .catch(() => null)
//     )
//   ).then(products => {
//     const validProducts = products.filter(Boolean);

//     if (!validProducts.length) {
//       container.innerHTML = "<p>No valid products found.</p>";
//       return;
//     }

//     container.innerHTML = "";

//     validProducts.forEach(product => {
//       const price = (product.price / 100).toFixed(2);

//       container.insertAdjacentHTML('beforeend', `
//         <div class="wishlist-item" data-handle="${product.handle}">
//           <a href="${product.url}" class="wishlist-link">
//             <img src="${product.images[0]}" alt="${product.title}">
//             <h3>${product.title}</h3>
//             <p>$${price}</p>
//           </a>

//           <div class="wishlist-actions">
            
//             <button class="wishlist-delete-icon" data-handle="${product.handle}">
//               Remove
//             </button>
//           </div>
//         </div>
//       `);
//     });

//     /* ===============================
//        Move to Cart (AJAX)
//     =============================== */
//     document.querySelectorAll('.wishlist-move-cart').forEach(button => {
//       button.addEventListener('click', function () {
//         const variantId = this.dataset.id;
//         const itemEl = this.closest('.wishlist-item');
//         const handle = itemEl.dataset.handle;

//         button.disabled = true;
//         const originalText = button.innerHTML;
//         button.innerHTML = 'Adding...';

//         fetch('/cart/add.js', {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/json' },
//           body: JSON.stringify({ id: variantId, quantity: 1 })
//         })
//           .then(res => res.json())
//           .then(() => {
//             toggleWishlist(handle);
//             itemEl.remove();

//             refreshCart();
//             openCartDrawer();

//             if (getWishlist().length === 0) {
//               container.innerHTML = "<p>Your wishlist is empty.</p>";
//             }
//           })
//           .catch(err => {
//             console.error(err);
//             button.disabled = false;
//             button.innerHTML = originalText;
//             alert('Failed to add product to cart');
//           });
//       });
//     });

//     /* ===============================
//        Delete from Wishlist
//     =============================== */
//     document.querySelectorAll('.wishlist-delete-icon').forEach(button => {
//       button.addEventListener('click', function () {
//         const handle = this.dataset.handle;
//         const itemEl = this.closest('.wishlist-item');

//         button.disabled = true;
//         toggleWishlist(handle);
//         itemEl.remove();

//         if (getWishlist().length === 0) {
//           container.innerHTML = "<p>Your wishlist is empty.</p>";
//         }
//       });
//     });
//   });
// });


document.addEventListener("DOMContentLoaded", function () {

  /* ===============================
     WISHLIST HELPERS
  =============================== */
  function getWishlist() {
    try {
      const data = JSON.parse(localStorage.getItem('wishlist'));
      return Array.isArray(data) ? data : [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(wishlist) {
    localStorage.setItem('wishlist', JSON.stringify(wishlist));
  }

  function isInWishlist(handle) {
    return getWishlist().includes(handle);
  }

  function updateWishlistCount() {
    const wishlist = getWishlist();
    document.querySelectorAll('[data-wishlist-count]').forEach(el => {
      el.textContent = wishlist.length;
      el.style.display = wishlist.length ? 'inline-flex' : 'none';
    });
  }

  function ensureWishlistCountOnLoad() {
    let attempts = 0;

    const interval = setInterval(() => {
      const el = document.querySelector('[data-wishlist-count]');
      if (el) {
        updateWishlistCount();
        clearInterval(interval);
      }

      attempts++;
      if (attempts > 20) clearInterval(interval);
    }, 250);
  }

  function toggleWishlist(handle) {
    let wishlist = getWishlist();

    if (wishlist.includes(handle)) {
      wishlist = wishlist.filter(item => item !== handle);
    } else {
      wishlist.push(handle);
    }

    saveWishlist(wishlist);
    updateWishlistCount();
  }

  /* ===============================
     BIND WISHLIST BUTTONS
  =============================== */
  function bindWishlistButtons(scope = document) {
    scope.querySelectorAll('.wishlist-button').forEach(button => {
      const handle = button.dataset.productHandle;
      if (!handle) return;

      button.classList.toggle('active', isInWishlist(handle));

      if (!button.dataset.bound) {
        button.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          toggleWishlist(handle);
          button.classList.toggle('active');
        });
        button.dataset.bound = "true";
      }
    });
  }

  /* ===============================
     INITIALIZE
  =============================== */
  ensureWishlistCountOnLoad();
  bindWishlistButtons();

  document.addEventListener('shopify:section:load', ensureWishlistCountOnLoad);

  /* ===============================
     OBSERVE HEADER RERENDER
  =============================== */
  const headerObserver = new MutationObserver(() => {
    ensureWishlistCountOnLoad();
  });

  headerObserver.observe(document.body, {
    childList: true,
    subtree: true
  });

  /* ===============================
     WISHLIST PAGE LOGIC
  =============================== */
  const wishlistPage = document.getElementById('wishlist-page');
  if (!wishlistPage) return;

  const container = document.getElementById('wishlist-products');
  const wishlist = getWishlist();

  if (!wishlist.length) {
    container.innerHTML = "<p>Your wishlist is empty.</p>";
    return;
  }

  container.innerHTML = "<p>Loading your wishlist...</p>";

  Promise.all(
    wishlist.map(handle =>
      fetch(`/products/${handle}.js`)
        .then(res => res.ok ? res.json() : null)
        .catch(() => null)
    )
  ).then(products => {
    const validProducts = products.filter(Boolean);

    if (!validProducts.length) {
      container.innerHTML = "<p>No valid products found.</p>";
      return;
    }

    container.innerHTML = "";

    validProducts.forEach(product => {
      const price = (product.price / 100).toFixed(2);

      container.insertAdjacentHTML('beforeend', `
        <div class="wishlist-item" data-handle="${product.handle}">
          <a href="${product.url}" class="wishlist-link">
            <img src="${product.images[0]}" alt="${product.title}">
            <h3>${product.title}</h3>
            <p>₹${price}</p>
          </a>

          <div class="wishlist-actions">
            <button class="wishlist-delete-icon" data-handle="${product.handle}">
              Remove
            </button>
          </div>
        </div>
      `);
    });

    /* ===============================
       DELETE FROM WISHLIST PAGE
    =============================== */
    document.querySelectorAll('.wishlist-delete-icon').forEach(button => {
      button.addEventListener('click', function () {
        const handle = this.dataset.handle;
        const itemEl = this.closest('.wishlist-item');

        toggleWishlist(handle);
        itemEl.remove();

        if (!getWishlist().length) {
          container.innerHTML = "<p>Your wishlist is empty.</p>";
        }
      });
    });
  });

});

